import { Component, HostListener, OnInit,ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { take,filter } from 'rxjs/operators';
import { CommonService } from './services/common.service';
import { AppState } from './store/state';
import { Countries } from './store/interfaces/countries.interface';
import { api } from './crypto-constants/api';
import { SET_COUNTRIES } from './store/actions/countries.action';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }

  title = 'crypto-frontend';
  countries$: Observable<Countries[]>;
  isLoading = false;

  constructor(
    private store: Store<AppState>,
    public commonService: CommonService,
    private httpClient: HttpClient,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.countries$ = store.select('countries');
    
    // Subscribe to loading state to avoid ExpressionChangedAfterItHasBeenCheckedError
    this.commonService.isLoading$.subscribe((loading) => {
      this.isLoading = loading;
      try {
        document.body.classList.toggle('global-loading', !!loading);
      } catch {
        /* ignore */
      }
      this.cdr.markForCheck();
    });
  }

  ngOnInit(): void {
    let previousUrl = '';
    
this.router.events
  .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
  .subscribe((event) => {
    const currentUrl = event.urlAfterRedirects;
    const blocked = ['/tutorial', '/verify-code', '/onboard/household-details'];

    if (!blocked.includes(currentUrl)) {
      localStorage.setItem('previousUrl', localStorage.getItem('currentUrl') || '');
    }

    localStorage.setItem('currentUrl', currentUrl);

    if (currentUrl.includes('/i-am-RA')) {
      this.commonService.setLoading(false);
      try {
        document.body.classList.remove('global-loading');
      } catch {
        /* ignore */
      }
    }
  });
    this.loadCountries();
    this.getCountry();
  }

  private loadCountries() {
    this.countries$.pipe(take(1)).subscribe((stateData: any) => {
      const storeCountries = stateData?.countries ?? [];

      if (storeCountries.length > 0) return;

      const localCountries = localStorage.getItem('countries');
      if (localCountries) {
        try {
          const parsed = JSON.parse(localCountries);
          if (Array.isArray(parsed) && parsed.length > 0) {
            this.store.dispatch({ type: SET_COUNTRIES, countries: parsed });
            return;
          }
        } catch (e) {
          console.warn('Invalid countries in localStorage', e);
        }
      }

      // Fallback: fetch from API
      this.httpClient.get(api.CountriesList).toPromise()
        .then((response: any) => {
          if (response?.success && Array.isArray(response.data)) {
            this.store.dispatch({ type: SET_COUNTRIES, countries: response.data });
            localStorage.setItem('countries', JSON.stringify(response.data));
          }
        })
        .catch(error => {
          console.error('Failed to fetch countries list', error);
        });
    });
  }

  private getCountry() {
    const storedCountry = localStorage.getItem("userCountryDetails");

    if (storedCountry && storedCountry !== "null" && storedCountry !== "{}") {
      console.log("Using stored country details:", JSON.parse(storedCountry));
      return;
    }

    const updateLocalCountry = (data: any) => {
      const countryData = {
        country_name: data.country || data.country_name,
        country_code: data.countryCode || data.country_code,
        city: data.city,
        region: data.regionName || data.state,
        latitude: data.lat || data.latitude,
        longitude: data.lon || data.longitude,
        ip: data.query || data.IPv4
      };

      if (JSON.stringify(countryData) !== storedCountry) {
        localStorage.setItem("userCountryDetails", JSON.stringify(countryData));
        console.log("Updated country details:", countryData);
        console.log("Updated country details:", countryData);
      }
      setTimeout(() => this.cdr.detectChanges(), 0);
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const response = await fetch(`https://geolocation-db.com/json/`);
          const data = await response.json();
          data.latitude = position.coords.latitude;
          data.longitude = position.coords.longitude;
          updateLocalCountry(data);
        },
        async (error) => {
          console.warn("Geolocation failed. Using IP lookup...", error);
          const response = await fetch("https://ip-api.com/json/");
          const data = await response.json();
          updateLocalCountry(data);
        }
      );
    } else {
      fetch("https://ip-api.com/json/")
        .then(res => res.json())
        .then(data => updateLocalCountry(data))
        .catch(err => console.error("IP Lookup failed", err));
    }
  }
}
